export default __webpack_public_path__ + "static/media/DCSPImg.405605ea.jpg";